<jsg-multi-row-panel>
  <jsg-single-row-panel *ngIf="styleOfCause" first>
    <div first>
      <div>Style of cause</div>
      <div>{{ styleOfCause }}</div>
    </div>
  </jsg-single-row-panel>
  <jsg-single-row-panel *ngIf="natureOfLitigation" second>
    <div first>
      <div>Nature of litigation</div>
      <div>{{ natureOfLitigation }}</div>
    </div>
  </jsg-single-row-panel>
</jsg-multi-row-panel>
<section class="section-background section-border">
  <table mat-table [dataSource]="dataSource">
    <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="roleType">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.roleLookupType?.description }}
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Party name</th>
      <td mat-cell *matCellDef="let element">
        {{
          element?.partyLookupType?.codeValue == 'ORG'
            ? element?.partyName
            : element?.firstName + ' ' + element?.lastName
        }}
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="counsel">
      <th mat-header-cell *matHeaderCellDef>Counsel</th>
      <td mat-cell *matCellDef="let element">
        <span [innerHTML]="element.counsel | commaLineBreak"></span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</section>
